import { Version } from '@angular/core';

export const VERSION = new Version('1.0.3');
